"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_ALIGN_TYPES = exports.TEXT_ALIGN_TYPES = exports.STRING_MATCHER_METHODS = exports.STATEFUL_MESSAGE_TYPES = exports.FORM_CONTROL_VALIDATION_STATES = exports.CSS_PREFIX = exports.CONTROL_SIZES = exports.ALLOWED_INFO_ICONS = void 0;
var CONTROL_SIZES = exports.CONTROL_SIZES = ['lg', 'md'];
var CSS_PREFIX = exports.CSS_PREFIX = 'sapcnqr';
var FORM_CONTROL_VALIDATION_STATES = exports.FORM_CONTROL_VALIDATION_STATES = ['error', 'warning', 'success', 'info', 'ai'];
var STATEFUL_MESSAGE_TYPES = exports.STATEFUL_MESSAGE_TYPES = ['error', 'info', 'success', 'warning', 'custom', 'ai'];
var ALLOWED_INFO_ICONS = exports.ALLOWED_INFO_ICONS = ['ai'];
var STRING_MATCHER_METHODS = exports.STRING_MATCHER_METHODS = ['startsWith', 'includes'];
var TEXT_ALIGN_TYPES = exports.TEXT_ALIGN_TYPES = ['left', 'right', 'center'];
var VERTICAL_ALIGN_TYPES = exports.VERTICAL_ALIGN_TYPES = ['top', 'middle', 'bottom'];